import { useSearchParams } from "react-router-dom";
import { FinancingCalculator } from "@/components/FinancingCalculator";
import { useSite, usePageSeo } from "@/context/SiteContext";

export default function FinancingPage() {
  const [searchParams] = useSearchParams();
  const price = Number(searchParams.get("price")) || 75000;
  const { content } = useSite();
  const page = content.page_financing || {};
  usePageSeo(page.seo_title || "Financing", page.seo_description || page.hero_description);

  return (
    <div className="min-h-screen bg-background" data-testid="financing-page">
      <div className="bg-zinc-950 border-b border-zinc-800 py-14">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-white">
            {page.hero_title || "Financing"}
          </h1>
          {page.hero_description && (
            <p className="text-zinc-400 mt-3 max-w-2xl">{page.hero_description}</p>
          )}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className={`grid grid-cols-1 ${page.show_calculator !== false ? "lg:grid-cols-5" : ""} gap-10`}>
          {page.show_calculator !== false && (
            <div className="lg:col-span-3">
              <FinancingCalculator defaultPrice={price} />
            </div>
          )}
          <div className={`${page.show_calculator !== false ? "lg:col-span-2" : ""} space-y-5`}>
            {(page.benefits || []).map((b, i) => (
              <div key={i} className="bg-card border border-[#262626] p-6" data-testid={`financing-benefit-${i}`}>
                <h3 className="font-display text-lg font-bold uppercase text-foreground mb-2">{b.title}</h3>
                <p className="text-sm text-zinc-400 leading-relaxed">{b.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
